export function perspectiveDetailKey(perspective, index) {
  return `${perspective}-detail-${index}`;
}
